import {getAwpClientHeaders} from '../session/awpRequestHeaders';

/**
 * fetch() to dash-api with AWP user/session tracing headers merged into init.
 * @param {string|Request} url
 * @param {RequestInit} [init]
 * @returns {Promise<Response>}
 */
export function fetchWithAwpHeaders(url, init) {
    const awp = getAwpClientHeaders();
    const next = init ? {...init} : {};
    const baseHeaders =
        next.headers instanceof Headers
            ? Object.fromEntries([...next.headers.entries()])
            : typeof next.headers === 'object' && next.headers !== null
              ? {...next.headers}
              : {};
    next.headers = {...awp, ...baseHeaders};
    return fetch(url, next);
}

export {getAwpClientHeaders} from '../session/awpRequestHeaders';
